import * as React from 'react';
import styled from 'styled-components';
import MuiFilledInput, { FilledInputProps as MuiFilledInputProps } from '@material-ui/core/FilledInput';

const StyledInput = styled(MuiFilledInput)``;

export type DSFilledInputProps = MuiFilledInputProps;
export const DSFilledInput: React.FC<DSFilledInputProps> = props => <StyledInput {...props} />;
DSFilledInput.displayName = 'DSFilledInput';
